import React from "react";
import {
  getCatalogShopSlug,
  getCatalogVendeur,
} from "../../catalog/catalogTenant";

const PageNotAvailable = () => {
  const vendeur = getCatalogVendeur();
  const slug = getCatalogShopSlug();
  const shopLabel =
    vendeur?.nom_de_la_boutique ||
    vendeur?.nom_boutique ||
    (slug ? slug : null);

  return (
    <div className="container-body-page-not-available">
      <div>
        <h1 className="title-page-not-available pb-3">
          {shopLabel
            ? `Le site ${shopLabel}`
            : "Ce catalogue"}
        </h1>
        <h3 className="text-page-not-available mt-3">
          est momentanément indisponible. <br /> Veuillez contacter
          l'administrateur.
        </h3>
      </div>
    </div>
  );
};

export default PageNotAvailable;
